import React from 'react'
import Media from 'sb-media'

import Mobile from './Mobile/Mobile'
import ExceptMobile from './ExceptMobile/ExceptMobile'


const Header = (props) => (
  <Media mobile>
    {
      (isMobile) => React.createElement(isMobile ? Mobile : ExceptMobile, props)
    }
  </Media>
)


export default Header
